import { Paper, Typography, useTheme } from '@mui/material';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import useShipmentStatistics from './useShipmentStatistics';

const ShipmentStatistics = () => {
  const theme = useTheme();
  const hook = useShipmentStatistics();
  return (
    <Paper elevation={3} sx={{ mt: '1rem', padding: '1rem', overflow: 'auto' }}>
      <Typography variant="body1" sx={{ fontWeight: 600, mb: '1rem' }}>
        Resumen de envíos generados
      </Typography>
      <ResponsiveContainer width="100%" height={250} minWidth={1000}>
        <LineChart width={1100} height={250} data={hook.chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            tickFormatter={(value, index) => {
              if (index % 2 === 0) {
                return value;
              }
              return '';
            }}
          />
          <YAxis />
          <Tooltip />
          <Legend
            verticalAlign="top"
            align="right"
            wrapperStyle={{ paddingLeft: '20px' }}
            formatter={(value) => (
              <span style={{ color: theme.palette.text.primary }}>
                {value === 'currentPeriod' ? 'Período actual' : 'Período anterior'}
              </span>
            )}
          />
          <Line type="monotone" dataKey="currentPeriod" stroke={theme.palette.primary.main} />
          <Line type="monotone" dataKey="previousPeriod" stroke={theme.palette.secondary.main} />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default ShipmentStatistics;
